<template>
    <div class="photowall-box">
        <div class="item-photo" v-for='(item,index) in paotoData' :key='index'
            :style='{backgroundImage:"url("+item.imgrul+")"}' @click='toPath(item.url)'>
            <h4 class="caption">{{item.name}}</h4>
            <h5 class="title">{{item.chinename}}</h5>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Photowall',
        data() {
            return {
                paotoData: [
                    {
                        name: 'COLLEGE',
                        chinename: '蓝鲸营销学院',
                        url:'/school',
                        imgrul: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20200625100012.jpg'
                    },
                    {
                        name: 'CONTACT',
                        chinename: '联系我们',
                        url:'/contact',
                        imgrul: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20200625095828.jpg'
                    },
                ]
            }
        },
        methods:{
            toPath(url){
                window.location.href=url
            }
        }
    }
</script>
<style scoped>
    .photowall-box {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 599px;
    }

    .item-photo::after {
        display: block;
        content: "";
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        position: absolute;
        top: 0;
        left:0;
        transition: all 0.8s;
    }

    .item-photo {
        background: #666666 no-repeat center center;
        background-size: cover;
        transition: all 0.5s;
        position: relative;
        cursor: pointer;
        overflow: hidden;
    }

    .item-photo:hover::after {
        height: 0%;
    }

    .caption {
        font-size: 24px;
        font-weight: bold;
        line-height: 29px;
        color: rgba(255, 255, 255, 1);
        margin-top: 76px;
        margin-left: 84px;
        position: relative;
        z-index: 3;
    }

    .title {
        margin-left: 84px;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        color: rgba(255, 255, 255, 1);
        position: relative;
        z-index: 3;
    }

    @media(max-width: 995px){
        .photowall-box {
            height: 120vw;
            grid-template-columns: 1fr;
            grid-template-rows: auto;
        }
        .caption {
        margin-top: 5%;
        margin-left: 5%;
    }

    .title {
        margin-left: 5%;
    }
    }
    /* @media(max-width: 1023px) {
        .photowall-box {
            height: 2200px;
            grid-template-columns: 1fr;
            grid-template-rows: auto;
        }

        .caption {
            font-size: 50px;
            line-height: 150%;
        }

        .title {
            font-size: 45px;
            line-height: 157%;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/home/photowall.vue